import { createApiClient } from "@/api";
import { type DataProviderSchema } from "@/utils";
import { getLocalFilteredSortedList } from "@/utils/listParams";

const apiClient = createApiClient("jsonld");
const BASE_URL = "/api/vpn/countries";

export const fetchCountriesListData = async () => {
  const response = await apiClient.GET(BASE_URL, {
    params: {
      query: {
        pagination: false,
      },
    },
  });

  const data = response.data?.["hydra:member"] ?? [];
  const total = response.data?.["hydra:totalItems"] ?? 0;

  return {
    data,
    total,
  };
};

export const countriesSchema: DataProviderSchema<"Country", "jsonld"> = {
  list: getLocalFilteredSortedList(fetchCountriesListData),
  detail: async ({ id }) => {
    const { data } = await apiClient.GET(`${BASE_URL}/{id}`, {
      params: {
        path: { id: String(id) },
      },
    });

    if (!data) throw new Error("Country not found");

    return { data };
  },
  edit: async ({ id, data: { code, name, heartbeatName } }) => {
    if (!code) throw Error("Code is required");
    const { data } = await apiClient.PUT(`${BASE_URL}/{id}`, {
      params: {
        path: { id: String(id) },
      },
      body: {
        code,
        name,
        heartbeatName,
      },
    });

    if (!data) throw Error("Something went wrong");

    return { data };
  },
  create: async ({ data: { code, name, heartbeatName } }) => {
    if (!code) throw Error("Code is required");
    const { data } = await apiClient.POST(BASE_URL, {
      body: {
        code,
        name,
        heartbeatName,
      },
    });

    if (!data) throw Error("Something went wrong");

    return {
      data,
    };
  },
};
